<template>
	<div class="appContainer">
		<div class="container">
			<div class="w-100 mb-4 noprint" v-if="!urlBrand && boleto.flash == '1' && !opcao_clicada">
				<p class="selecioneTexto text-center pb-3 pt-5">
					Selecione onde irá pagar o boleto:
				</p>
				
				<div v-for="item in listaBanco"
				 	:key="item"
					class="bankOpt bg-white p-2 w-100"
					v-if="boletoAtivo(item)"
					@click="selecionaBanco(item)"
					@mouseover.self="mouseOver($event.target)"
					@mouseleave="mouseLeave()">

					<img src="~@/assets/img/bb.svg"			v-if="item == '001'">
					<img src="~@/assets/img/cef.svg"		v-if="item == '104'">
					<img src="~@/assets/img/itau.svg"		v-if="item == '341'">
					<img src="~@/assets/img/bradesco.svg"	v-if="item == '237'">
					<img src="~@/assets/img/santander.svg"	v-if="item == '033'">

					<label class="ml-4">{{descricaoBanco(item)}}</label>
					<div class="setaBancoRight">&nbsp;</div>
				</div>

				<div class="bankOpt bg-white p-2 w-100" @click="selecionaBanco('')" @mouseover.self="mouseOver($event.target)" @mouseleave="mouseLeave()">
					<img src="~@/assets/img/outros.svg">
					<label class="ml-4">Outros bancos</label>
					<div class="setaBancoRight">&nbsp;</div>
				</div>

				<div
					v-if="boletoAtivo('PIX')"
					class="bankOpt bg-white p-2 w-100"
					@click="selecionaBanco('PIX')"
					@mouseover.self="mouseOver($event.target)"
					@mouseleave="mouseLeave()">

					<img src="~@/assets/img/icon-pix.svg">
					<label class="ml-4">Pague com Pix</label>
					<div class="setaBancoRight">&nbsp;</div>
				</div>
			</div>
			
			<div class="w-100 mb-4 noprint" style="background-color: #4D4D4F; height: 1px; opacity: 0.2;" v-if="try_register[opt] && !urlBrand && boleto.flash == '1' && !opcao_clicada">
				&nbsp;
			</div>
			
			<div class="w-100 p-4 bg-white" v-if="try_register[opt] && opt != 'PIX'">

				<CabecalhoFlashImpressao />
				
				<div class="mb-2">	
					<div class="recibo_text" v-if="!(boleto.logo != null && boleto.logo != '')">
						<div>
							Recibo do Pagador
						</div>
					</div>
					<table class="boleto">
						<tr>
							<td style="width:100px;border:0px;"></td>
							<td style="width:100px;border:0px;"></td>
							<td style="width:100px;border:0px;"></td>
							<td style="width:100px;border:0px;"></td>
							<td style="width:100px;border:0px;"></td>
							<td style="width:100px;border:0px;"></td>
						</tr>
						<tr v-if="boleto.logo != null && boleto.logo != ''">
							<td colspan=2 style="border-left:0px;border-right:0px;border-top:0px;height:35px">
								<img :src="'data:image/svg+xml;base64,' + boleto.logo" border=0 v-if="boleto.logo_boleto_ext == 'SVG'" style="max-width: 170px; max-height:35px;">
								<img :src="'data:image/png;base64,' + boleto.logo" border=0 v-else>
							</td>
							<td :colspan="(boleto.logo != null && boleto.logo != '' ? 3 : 5)"
								:style="'border-right:0px;border-top:0px;height:35px;padding-left:3px;' + (boleto.logo != null && boleto.logo != '' ? '' : 'border-left:0;')">
								<sup>Empresa</sup>
								<div>{{boleto.merchant_name}}</div>
							</td>
							<td style="border-left:0px;border-right:0px;border-top:0px;">
								<div style="float:right;top: 10px;position: relative;">
									Recibo do Pagador
								</div>
							</td>
						</tr>
						<tr v-else>
							<td colspan=6>
								<sup>Empresa</sup>
								<div>{{boleto.merchant_name}}</div>
							</td>
						</tr>
						<tr>
							<td colspan=4 style="width: 330px;">
								<sup>Beneficiário/Processadora</sup>
								<div>PAGBRASIL PAGAMENTOS ELETRONICOS LTDA</div>
							</td>
							<td style="width: 160px;">
								<sup>Agência/Código Beneficiário</sup>
								<div class="text-center">
									{{ag_beneficiario}}
								</div>
							</td>
							<td style="width: 160px;">
								<sup>Vencimento</sup>
								<div class="text-center notranslate">
									{{$helper.formatDate(boleto.data_vencimento)}}
								</div>
							</td>
						</tr>
						<tr>
							<td colspan=4>
								<sup>Pagador</sup>
								<div>
									{{boleto.cliente_nome}}
								</div>
							</td>
							<td>
								<sup>Nro. do Documento</sup>
								<div class="text-center">
									{{boletobanco.nosso_numero}}
								</div>
							</td>
							<td>
								<sup>Nosso Número</sup>
								<div class="text-center">
									{{boletobanco.nosso_numero}}
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<sup>Espécie</sup>
								<div class="text-center">R$</div>
							</td>
							<td colspan=2>
								<sup>Quantidade</sup>
								<div>&nbsp;</div>
							</td>
							<td>
								<sup>(x) Valor</sup>
								<div>&nbsp;</div>
							</td>
							<td>
								<sup>(=) Valor do Documento</sup>
								<div class="text-center">
									{{$helper.formatValue(boleto.valor)}}
								</div>
							</td>
							<td>
								<sup>(-) Desconto</sup>
								<div>&nbsp;</div>
							</td>
						</tr>
						<tr>
							<td colspan=4>
								<sup>&nbsp;</sup>
								<div>Demonstrativo:</div>
							</td>
							<td>
								<sup>(+) Outros Acréscimos</sup>
								<div>&nbsp;</div>
							</td>
							<td>
								<sup>(=) Valor Cobrado</sup>
								<div>&nbsp;</div>
							</td>
						</tr>
						<tr>
							<td colspan=6 class="demonstrativo">
								Pedido de Compra Nro. {{boleto.order}}<br>
								<span v-if="boleto.exibir_produto == '1'" v-html="boleto.produto">
									<br>
								</span>
								<br>
								<span v-html="boleto.texto_boleto"></span>
							</td>
						</tr>
					</table>
					<div class="autent_text">
						<div>
							Autenticação Mecânica
						</div>
					</div>

					<div class="line_cut">
						<div class="first"></div>
						<div class="second">Corte Aqui</div>
						<div class="third"></div>
					</div>

					<div class="cabec_boleto">
						<div id="logo_img">
							<img src="~@/assets/img/001.jpg" v-if="opt == '001'">
							<img src="~@/assets/img/033.jpg" v-else-if="opt == '033'">
							<img src="~@/assets/img/104.jpg" v-else-if="opt == '104'">
							<img src="~@/assets/img/237.jpg" v-else-if="opt == '237'">
							<img src="~@/assets/img/341.jpg" v-else-if="opt == '341'">
						</div>
						<div id="numero_banco" v-if="opt == '001'">001-9</div>
						<div id="numero_banco" v-else-if="opt == '033'">033-7</div>
						<div id="numero_banco" v-else-if="opt == '104'">104-0</div>
						<div id="numero_banco" v-else-if="opt == '237'">237-2</div>
						<div id="numero_banco" v-else-if="opt == '341'">341-7</div>
						<div id="linha_digitavel">
							{{boletobanco.linha_digitavel | linha_quebra}}
						</div>
					</div>
					<table class="boleto">
						<tr>
							<td colspan=6>
								<sup>Local de Pagamento</sup>
								<div>Até o vencimento pagável em qualquer banco</div>
							</td>
							<td>
								<sup>Vencimento</sup>
								<div class="text-center notranslate">
									{{$helper.formatDate(boleto.data_vencimento)}}
								</div>
							</td>
						</tr>
						<tr>
							<td colspan=6>
								<sup>Beneficiário/Processadora</sup>
								<div>
									PAGBRASIL PAGAMENTOS ELETRONICOS LTDA - CNPJ 14.630.124/0001-65
								</div>
							</td>
							<td>
								<sup>Agência/Código Beneficiário</sup>
								<div class="text-center">
									{{ag_beneficiario}}
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<sup>Data Documento</sup>
								<div class="text-center notranslate">
									{{$helper.formatDate(boleto.data_processamento)}}
								</div>
							</td>
							<td colspan="2">
								<sup>Nro. do Documento</sup>
								<div class="text-center">
									{{boletobanco.nosso_numero}}
								</div>
							</td>
							<td>
								<sup>Espécie Doc.</sup>
								<div class="text-center">
									{{boletobanco.especie}}
								</div>
							</td>
							<td>
								<sup>Aceite</sup>
								<div class="text-center">N</div>
							</td>
							<td>
								<sup>Data Processam.</sup>
								<div class="text-center notranslate">
									{{$helper.formatDate(boleto.data_processamento)}}
								</div>
							</td>
							<td>
								<sup>Nosso Número</sup>
								<div class="text-center">
									{{boletobanco.nosso_numero}}
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<sup>Uso do banco</sup>
								<div class="text-center">
									&nbsp;
								</div>
							</td>
							<td>
								<sup>Carteira</sup>
								<div class="text-center">
									{{boletobanco.carteira}}
								</div>
							</td>
							<td>
								<sup>Espécie</sup>
								<div class="text-center">R$</div>
							</td>
							<td colspan="2">
								<sup>Quantidade</sup>
								<div>&nbsp;</div>
							</td>
							<td>
								<sup>(x) Valor</sup>
								<div>&nbsp;</div>
							</td>
							<td>
								<sup>(=) Valor do Documento</sup>
								<div class="text-center">
									{{$helper.formatValue(boleto.valor)}}
								</div>
							</td>
						</tr>
						<tr>
							<td colspan="6" rowspan="4" style="vertical-align:top">
								<sup>
									<b>
										Instruções (texto de responsabilidade do Beneficiário)
									</b>
								</sup>
								<div class="text_normal">
									NÃO RECEBER APÓS VENCIMENTO
								</div>
							</td>
							<td>
								<sup>(-) Desconto</sup>
							</td>
						</tr>
						<tr>
							<td>
								<sup>(+) Mora/Multa</sup>
							</td>
						</tr>
						<tr>
							<td>
								<sup>(+) Outros Acréscimos</sup>
							</td>
						</tr>
						<tr>
							<td>
								<sup>(=) Valor Cobrado</sup>
							</td>
						</tr>

						<tr>
							<td colspan="7" class="info_pagador">
								<div class="text_normal div_pagador">
									Pagador
								</div>
								<div class="div_pagador_info">
									{{boleto.cliente_nome}}
									<div v-if="boleto.allinfbol != 'N'">
										{{boleto.cliente_cpfcnpj | cpfcnpj}} {{boleto.cliente_cpfcnpj}}<br>
										{{boleto.cliente_endereco}}<span v-if="boleto.cliente_cep != ''"> - CEP {{boleto.cliente_cep}}</span><br>
										{{boleto.cliente_cidade}}/{{boleto.cliente_estado}}
									</div>
									<div v-else>
										<br>
										<br>
										<br>
									</div>
								</div>
								<div class="text_normal div_pagador_avalista">
									Pagador/Avalista
								</div>
							</td>
						</tr>
					</table>

					<div class="rodape_boleto">
						<div id="codigo_barras">
							<img :src="barcode_aux" v-if="refresh">
						</div>
						<div id="ficha_compensacao">
							Ficha de Compensação
							<div class="text_normal">
								Autenticação Mecânica
							</div>
						</div>
					</div>
					<div class="line_cut">
						<div class="first"></div>
						<div class="second">Corte Aqui</div>
						<div class="third"></div>
					</div>
				</div>

				<div class="w-100 text-center mb-5 noprint">
					<!--
					<a id="bt-print-orange" href="javascript:window.print();" class="bt-print-orange py-3 d-inline-block">
						<label for="bt-print-orange" class="ml-2">Imprimir o boleto</label>
					</a>
					-->
				</div>
			</div>

			<div class="container w-100 p-4" v-if="opt == 'PIX'">
				<PaymentMethodPix />
			</div>
		</div>
		
		<div v-if="boleto.flash == '1' && !try_register[opt]" class="footer py-4 w-100">
			<div class="container">
				<p v-html="boleto.texto_boleto"></p>
				
				<div class="hr my-3">&nbsp;</div>
				
				<p>
					Boleto processado pela <b>PagBrasil</b>. 
				</p>
				
			</div>
		</div>

		<Loader />
	</div>
</template>

<script>
	import CabecalhoFlashImpressao from '@/components/CabecalhoFlashImpressao.vue'
	import PaymentMethodPix from '@/components/PaymentMethodPix.vue'
	import Loader from '@/components/Loader.vue'

	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'BoletoDesktopA',

		components: {
			CabecalhoFlashImpressao,
			PaymentMethodPix,
			Loader
		},

		data () {
			return {
				refresh: false
			}
		},

		mounted: function(){
			let self = this;

			this.$nextTick(() => {
				self.refreshImg();
			});
		},

		computed: {
			boleto(){
				return this.$store.state.boleto.boleto;
			},

			opt(){
				return this.$store.state.boleto.opt;
			},

			opt_outro(){
				return this.$store.state.boleto.opt_outro;
			},

			opt_pix(){
				return this.$store.state.boleto.opt_pix;
			},

			ag_beneficiario(){
				return this.$store.state.boleto.ag_beneficiario;
			},

			boletobanco(){
				return this.$store.state.boleto.boletobanco;
			},

			try_register(){
				return this.$store.state.boleto.try_register;
			},

			boletonotfound(){
				return this.$store.state.boleto.boletonotfound;
			},

			opcao_clicada(){
				return this.$store.state.boleto.opcao_clicada;
			},

			boleto_permitido(){
				return this.$store.state.boleto.boleto_permitido;
			},

			listaBanco(){
				return this.$store.state.boleto.listaBanco;
			},

			barcode_aux(){
				var baseUrl = process.env.VUE_APP_BASEURL + ':' + process.env.VUE_APP_BASEURLPORT + "./_api/";
				if(process.env.NODE_ENV != 'development'){
					baseUrl = process.env.VUE_APP_BASEURL;
				}

				let aux = baseUrl + 'getBarcode.php?';
				aux += 'valor=';

				let valor = '00000000000000000000000000000000000000000000';
				if(typeof this.boletobanco.barcode != "undefined"){
					valor = this.boletobanco.barcode;
				}

				let cont = 0;
				for(let i=0; i< valor.length; i++){
					cont += parseInt(valor[i]);
				}

				aux += valor + "_" + cont;

				return aux;
			},
			
			urlBrand(){
				return this.$store.state.boleto.urlBrand;
			},
		},

		methods:{
			...mapActions({
				tryRegistro: 'boleto/tryRegistro'
			}),

			selecionaBanco(banco){
				let self = this;
				this.tryRegistro(banco).then(function(){
					self.$store.commit("boleto/setOpcaoClicada", true);
					self.refreshImg();
				});
				
			},

			boletoAtivo(val){
				if(this.boleto_permitido.indexOf(val) != -1){
					return true;
				}
				return false;
			},

			refreshImg(){
				let self = this;
				self.refresh = false;
				window.setTimeout(
					function(){
						self.refresh = true;
					},
					50);
			},

			setOpcaoClicada(val){
				this.$store.commit("boleto/setOpcaoClicada", false);
			},
			
			mouseLeave(){
				let allEls = document.querySelectorAll(".bankOpt");
				Array.prototype.forEach.call(allEls, (v, k) => {
					v.classList.remove("selected");
					v.classList.remove("unselected");
				});
			},
			
			mouseOver(element){
				
				this.mouseLeave();
				
				let el = element;
				let allEls = document.querySelectorAll(".bankOpt");
				
				el.classList.add("selected");
				
				Array.prototype.forEach.call(allEls, (v, k) => {
					if(!v.classList.contains("selected")){
						v.classList.add("unselected");
					}
				});
			},

			descricaoBanco(banco){
				return this.$store.getters["boleto/descricaoBanco"](banco);
			},
			
		},

		filters:{
			linha_quebra (val){
				if(typeof val == "undefined" || val == ''){
					return '';
				}
				let ret = val.substr(0,5);
				ret += ".";
				ret += val.substr(5,5);
				ret += " ";
				ret += val.substr(10,5);
				ret += ".";
				ret += val.substr(15,6);
				ret += " ";
				ret += val.substr(21,5);
				ret += ".";
				ret += val.substr(26,6);
				ret += " ";
				ret += val.substr(32,1);
				ret += " ";
				ret += val.substr(33);

				return ret;
			},

			cpfcnpj (val){
				if(val && typeof val != "undefined"){
					if(val.length > 11){
						return 'CNPJ';
					}else{
						return 'CPF';
					}
				}

				return '';
			}
		}
	}

</script>